import { logAndSetStoreValue } from './logAndSetStoreValue'
import { TEntityMaskDataValueTypes } from '~/types/models'
import { useEntityDialogStore } from '~/stores/entityDialog'

export interface IValueToPassToSubentityDialog {
  fieldName: string
  value: TEntityMaskDataValueTypes
}

export interface ISetShowSubentityDialog {
  callingMn: String
  entityName: String
  entityData?: any // Will have a value if we're updating or deleting, but not creating
  subentityNameTitleOverride?: string | null
  subentityInputFieldsEntityNameOverride?: string | undefined // Will only have a value if we want to use other than the 'real' entityName to get the inputFields
  valuesForSubentityFieldsWhoseValuesToSetFromEntityFields?: IValueToPassToSubentityDialog[]
  subentityAfterRequestProcessor?: Function | undefined
  subentityParentObjectForCreate?: Function | undefined // Wil only have a value if subentity is itself child (e.g. adding a new companyContact to locationCompanyContacts)
}

export async function setShowSubentityDialog(obj: ISetShowSubentityDialog) {
  const {
    callingMn,
    entityName,
    subentityNameTitleOverride,
    subentityInputFieldsEntityNameOverride,
    valuesForSubentityFieldsWhoseValuesToSetFromEntityFields,
    subentityAfterRequestProcessor,
    subentityParentObjectForCreate,
  } = obj

  const fn = `${callingMn} --> [cynqueModules/setShowSubentityDialog.ts] setShowSubentityDialog |`

  await logAndSetStoreValue({
    fn,
    storePropertyName: 'subentityName',
    value: entityName,
  })

  if (subentityNameTitleOverride) {
    await logAndSetStoreValue({
      fn,
      storePropertyName: 'subentityNameTitleOverride',
      value: subentityNameTitleOverride,
    })
  }

  if (subentityInputFieldsEntityNameOverride) {
    await logAndSetStoreValue({
      fn,
      storePropertyName: 'subentityInputFieldsEntityNameOverride',
      value: subentityInputFieldsEntityNameOverride,
    })
  }

  if (valuesForSubentityFieldsWhoseValuesToSetFromEntityFields) {
    await logAndSetStoreValue({
      fn,
      storePropertyName:
        'valuesForSubentityFieldsWhoseValuesToSetFromEntityFields',
      value: valuesForSubentityFieldsWhoseValuesToSetFromEntityFields,
    })
  }

  if (subentityAfterRequestProcessor) {
    await logAndSetStoreValue({
      fn,
      storePropertyName: 'subentityAfterRequestProcessor',
      value: subentityAfterRequestProcessor,
    })
  }

  if (subentityParentObjectForCreate) {
    await logAndSetStoreValue({
      fn,
      storePropertyName: 'subentityParentObjectForCreate',
      value: subentityParentObjectForCreate,
    })
  }

  // Actually show it
  console.debug(
    `${obj.callingMn} --> [cynqueModules/setShowSubentityDialog.ts]` +
      ` setShowSubentityDialog | Setting showSubentityDialog to: true`
  )
  // NOT `obj.useEntityDialogStore()`. Under Vuex this was
  // `obj.store.dispatch('entityDialog/setShowSubentityDialog', true)` — the
  // params object really did carry a `store`. The Pinia conversion dropped that
  // param but left the receiver attached, so this threw "obj.useEntityDialogStore
  // is not a function" and the subentity dialog never opened. The composable is
  // imported at the top of this module; call it directly.
  useEntityDialogStore().setShowSubentityDialog(true)
}

// console.debug(`${mn} fired. Setting subentityName to: ${obj.entityName}`)

// await obj.store.dispatch(`entityDialog/setSubentityName`, obj.entityName, {
//   root: true,
// })

// if (obj.subentityNameTitleOverride) {
//   console.debug(`${mn}  Setting subentityNameTitleOverride`)
//   await obj.store.dispatch(
//     `entityDialog/setSubentityNameTitleOverride`,
//     obj.subentityNameTitleOverride,
//     {
//       root: true,
//     }
//   )
// }

// if (obj.subentityInputFieldsEntityNameOverride) {
//   console.debug(`${mn}  Setting subentityInputFieldsEntityNameOverride`)
//   await obj.store.dispatch(
//     `entityDialog/setSubentityInputFieldsEntityNameOverride`,
//     obj.subentityInputFieldsEntityNameOverride,
//     {
//       root: true,
//     }
//   )
// }

// if (obj.valuesForSubentityFieldsWhoseValuesToSetFromEntityFields) {
//   console.debug(
//     `${mn}  Setting valuesForSubentityFieldsWhoseValuesToSetFromEntityFields`
//   )
//   await obj.store.dispatch(
//     `entityDialog/setValuesForSubentityFieldsWhoseValuesToSetFromEntityFields`,
//     obj.valuesForSubentityFieldsWhoseValuesToSetFromEntityFields,
//     {
//       root: true,
//     }
//   )
// }

// if (obj.subentityAfterRequestProcessor) {
//   console.debug(`${mn}  Setting subentityAfterRequestProcessor`)
//   await obj.store.dispatch(
//     `entityDialog/setSubentityAfterRequestProcessor`,
//     obj.subentityAfterRequestProcessor,
//     {
//       root: true,
//     }
//   )
// }

// if (obj.subentityParentObjectForCreate) {
//   console.debug(`${mn}  Setting subentityParentObjectForCreate`)
//   await obj.store.dispatch(
//     `entityDialog/setSubentityParentObjectForCreate`,
//     obj.subentityParentObjectForCreate,
//     {
//       root: true,
//     }
//   )
// }
